(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knit-b2g1-funnel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript.closest('.knit-funnel');
    if (!root) return;

    const products = {};
    root.querySelectorAll('[data-funnel-product]').forEach((node) => {
      try { products[node.dataset.funnelProduct] = JSON.parse(node.textContent); } catch (error) { products[node.dataset.funnelProduct] = []; }
    });

    const slots = [...root.querySelectorAll('[data-slot]')];
    const addButton = root.querySelector('.knit-funnel__add');
    const progressBar = root.querySelector('.knit-funnel__progress-track i');
    const progressCount = root.querySelector('.knit-funnel__progress strong');
    const status = root.querySelector('.knit-funnel__status');

    const updateProgress = () => {
      const completed = slots.filter((slot) => slot.querySelector('select').value).length;
      progressCount.textContent = completed;
      progressBar.style.width = `${(completed / 3) * 100}%`;
      addButton.disabled = completed !== 3;
    };

    slots.forEach((slot) => {
      const select = slot.querySelector('select');
      slot.querySelectorAll('[data-product]').forEach((button) => {
        button.addEventListener('click', () => {
          slot.querySelectorAll('[data-product]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          const variants = products[button.dataset.product] || [];
          select.innerHTML = '<option value="">اختار اللون والمقاس</option>';
          variants.filter((variant) => variant.available).forEach((variant) => {
            const option = document.createElement('option');
            option.value = String(variant.id).replace('gid://shopify/ProductVariant/', '');
            option.textContent = variant.title;
            select.appendChild(option);
          });
          select.disabled = false;
          select.value = '';
          updateProgress();
        });
      });
      select.addEventListener('change', updateProgress);
    });

    addButton.addEventListener('click', async () => {
      const selected = slots.map((slot) => slot.querySelector('select').value).filter(Boolean);
      if (selected.length !== 3) return;
      const quantities = selected.reduce((result, id) => {
        result[id] = (result[id] || 0) + 1;
        return result;
      }, {});
      const items = Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity }));
      addButton.disabled = true;
      status.textContent = root.dataset.successMessage;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = root.dataset.errorMessage;
        addButton.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knit-collection-funnel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.knit-shop');
    if (!root) return;

    const choices = [];
    const tray = root.querySelector('[data-selected-items]');
    const trayCount = root.querySelector('[data-tray-count]');
    const navCount = root.querySelector('[data-nav-count]');
    const checkout = root.querySelector('[data-checkout]');
    const status = root.querySelector('[data-status]');

    const render = () => {
      tray.innerHTML = '';
      choices.forEach((choice, index) => {
        const item = document.createElement('div');
        item.className = 'knit-shop__selected-item';
        item.innerHTML = `${choice.image ? `<img src="${choice.image}" alt="">` : ''}<div><b></b><span></span></div><button type="button" class="knit-shop__remove" aria-label="Remove">×</button>`;
        item.querySelector('b').textContent = choice.productTitle;
        item.querySelector('span').textContent = choice.variantTitle;
        item.querySelector('button').addEventListener('click', () => {
          choices.splice(index, 1);
          render();
        });
        tray.appendChild(item);
      });
      for (let slot = choices.length + 1; slot <= 3; slot += 1) {
        const empty = document.createElement('div');
        empty.className = 'knit-shop__selected-slot';
        empty.innerHTML = `<i>${slot}</i><span>اختار قطعة</span>`;
        tray.appendChild(empty);
      }
      trayCount.textContent = choices.length;
      navCount.textContent = choices.length;
      checkout.disabled = choices.length !== 3;
    };

    root.querySelectorAll('[data-product-card]').forEach((card) => {
      const select = card.querySelector('[data-variant-select]');
      const button = card.querySelector('[data-add-choice]');
      const cardImage = card.querySelector('.knit-shop__media img');
      const originalImage = button.dataset.image;
      const originalDisplayImage = cardImage ? cardImage.currentSrc || cardImage.src : '';
      select.addEventListener('change', () => {
        button.disabled = !select.value;
        const selectedOption = select.options[select.selectedIndex];
        const variantImage = selectedOption.dataset.variantImage;
        const variantThumb = selectedOption.dataset.variantThumb;
        if (cardImage && variantImage) {
          cardImage.srcset = '';
          cardImage.src = variantImage;
        } else if (cardImage && originalDisplayImage) {
          cardImage.srcset = '';
          cardImage.src = originalDisplayImage;
        }
        button.dataset.image = variantThumb || originalImage;
      });
      button.addEventListener('click', () => {
        if (choices.length >= 3) {
          status.textContent = root.dataset.limitMessage;
          setTimeout(() => { status.textContent = ''; }, 2400);
          return;
        }
        const selectedOption = select.options[select.selectedIndex];
        choices.push({
          id: select.value.replace('gid://shopify/ProductVariant/', ''),
          productTitle: card.dataset.productTitle,
          variantTitle: selectedOption.dataset.variantTitle || selectedOption.textContent,
          image: button.dataset.image
        });
        render();
        if (choices.length === 3) root.querySelector('[data-selection-tray]').scrollIntoView({ behavior: 'smooth', block: 'end' });
      });
    });

    checkout.addEventListener('click', async () => {
      if (choices.length !== 3) return;
      const quantities = choices.reduce((result, choice) => {
        result[choice.id] = (result[choice.id] || 0) + 1;
        return result;
      }, {});
      const items = Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity }));
      checkout.disabled = true;
      status.textContent = root.dataset.loadingMessage;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = root.dataset.errorMessage;
        checkout.disabled = false;
      }
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
